"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _hotjar = _interopRequireDefault(require("./hotjar.proptypes"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Hotjar = function Hotjar(props) {
  var loginstatus = props.loginstatus,
    memberid = props.memberid,
    currency = props.currency,
    lineofbusiness = props.lineofbusiness,
    gaid = props.gaid,
    userID = props.userID;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    scriptLoaded = _useState2[0],
    setScriptLoaded = _useState2[1];
  var addHotjar = function addHotjar() {
    var scriptlet = document.querySelector("script[data-hotjar]");
    if (scriptlet) {
      return;
    }
    var hotjarScript = "\n        (function(h,o,t,j,a,r){\n        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n        h._hjSettings={hjid:135798,hjsv:6};\n        a=o.getElementsByTagName('head')[0];\n        r=o.createElement('script');r.async=1;\n        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n        a.appendChild(r);\n        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');\n    ";
    var scriptTag = document.createElement('script');
    scriptTag.setAttribute('async', '');
    scriptTag.setAttribute('data-hotjar', '');
    scriptTag.setAttribute('type', 'application/javascript');
    var code = hotjarScript;
    try {
      scriptTag.appendChild(document.createTextNode(code));
    } catch (e) {
      scriptTag.text = code;
    }
    document.head.appendChild(scriptTag);
    setScriptLoaded(true);
  };
  (0, _react.useEffect)(function () {
    addHotjar();
  }, []);
  var sendValuesToHotjar = (0, _react.useCallback)(function () {
    if (typeof window === 'undefined') {
      return;
    }
    if (!window.hj) {
      return;
    }
    var hjUserId = userID || null;
    window.hj('identify', hjUserId, {
      loginstatus: loginstatus,
      memberid: memberid,
      currency: currency,
      lineofbusiness: lineofbusiness,
      gaid: gaid
    });
  }, [loginstatus, memberid, currency, lineofbusiness, gaid, userID]);
  (0, _react.useEffect)(function () {
    if (scriptLoaded) {
      sendValuesToHotjar();
    }
  }, [loginstatus, memberid, currency, lineofbusiness, gaid, userID, scriptLoaded, sendValuesToHotjar]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
Hotjar.propTypes = _hotjar.default.PropTypes;
Hotjar.defaultProps = _hotjar.default.DefaultProps;
var _default = Hotjar;
exports.default = _default;